import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export type CompactType = {
  isCompact: boolean;
};

const initialState: CompactType = {
  isCompact: true,
};

const compactSlice = createSlice({
  name: 'compact',
  initialState,
  reducers: {
    setCompact: (state, action) => {
      state.isCompact = action.payload;
    },
  },
});

export const { setCompact } = compactSlice.actions;

export const selectIsCompact = (state: RootState) => state.compact.isCompact;

export default compactSlice.reducer;
